// Icon.tsx
import React from "react";
import { IconProps } from "../../../Interface/interface";

const Icon: React.FC<IconProps> = ({ src, alt, className, style ,onClick,loading}) => {
  return (
    <img src={src} alt={alt} className={className} style={style} onClick={onClick} loading={loading}></img>
  );
};

export default Icon;